import { BASE_URL } from '@lib/config';

export const IS_BROWSER = typeof window !== 'undefined';

export const CONTACT_CONSTANTS = {
    ISSUE_TYPE: ['General', 'Purchaser', 'Recipient/Cardholder', 'Merchant'],
} as const;

const PASSWORD_CONSTANTS = {
    PATTERN:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^])[A-Za-z\d@$!%*?&^]{8,}$/,
    PATTERN_MESSAGE:
        'Password length must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one number, and one special character (@, $, !, %, *, ?, &, ^).',
} as const;

export default PASSWORD_CONSTANTS;

export const CARD_PROGRAMS = {
    KEY: 'GCM_CARD_PROGRAM',
    RESTAURANT: 'restaurant',
    SPAS_AND_SALON: 'spa',
    SERVICEPROVIDER: 'serviceprovider',
    CHOOSE_YOUR_OWN: 'choose_your_own', //default value
    CHOOSE_YOUR_OWN_RESTAURANT: 'choose_your_own_restaurant',
    CHOOSE_YOUR_OWN_SPAS_SALONS: 'choose_your_own_spas_and_salons',
    CHOOSE_YOUR_OWN_SERVICES: 'choose_your_own_serviceprovider',
    CHOOSE_YOUR_OWN_HOME_SERVICES: 'choose_your_own_serviceprovider_home',
    CHOOSE_YOUR_OWN_PERSONAL_SERVICES: 'choose_your_own_serviceprovider_personal',
    CHOOSE_YOUR_OWN_AUTO_SERVICES: 'choose_your_own_serviceprovider_auto',
    CHOOSE_YOUR_OWN_RESTAURANT_BARS: 'choose_your_own_restaurant_bars',
    CHOOSE_YOUR_OWN_RESTAURANT_COFFEE: 'choose_your_own_restaurant_coffee',
    CHOOSE_YOUR_OWN_RESTAURANTS_SPAS_SALONS: 'choose_your_own_restaurants_spas_salons',
} as const;

export const CARD_PROGRAMS_SEARCH = {
    choose_your_own_restaurant: 'restaurant',
    choose_your_own_spas_and_salons: 'spa',
    choose_your_own_service: 'serviceprovider',
    choose_your_own: 'restaurant;spa',
} as any;


/**
 * Customer service contact information
 * Note: These are typically build-time constants for static contact info.
 * For runtime configuration, use useApi().config.CUSTOMER_SERVICE_PHONE_NUMBER
 * or useApi().config.GIFT_CARD_MARKET_EMAIL in client components.
 */
export const CUSTOMER_SERVICE_PHONE_NUMBER =
    process.env.CUSTOMER_SERVICE_PHONE_NUMBER || '1-855-798-2146';
export const CUSTOMER_SERVICE_PHONE_NUMBER_TEL =
    CUSTOMER_SERVICE_PHONE_NUMBER.replace(/-/g, '');
export const GIFT_CARD_MARKET_EMAIL =
    process.env.GIFT_CARD_MARKET_EMAIL || 'giftcardmarket.com';

export const REFERRAL_EXPIRED_KEY = 'referral_expired';
export const REFERRAL_KEY_NAME = 'referral';
export const AWC_KEY_NAME = 'awc';
export const AWC_EXPIRED_KEY = 'awc_expired';
export const FG_TOKEN_kEY_NAME = 'fg_token';
export const FLIP_GIVE = 'flip';

export const DELIVERY_TYPES = {
  SEND_TO_MYSELF: 'send_to_myself',
  SEND_TO_SOME_ELSE: 'send_to_some_else',
  PRINT_AND_GIVE: 'print_and_give',
} as const;

export const REDEMPTION_METHODS = {
    EMAIL: 'Email',
    TEXT: 'Text',
    PRINT: 'Print',
} as const;

export const CARD_PROGRAM_DISPLAY = {
    RESTAURANT: 'restaurant',
    SPAS_AND_SALON: 'spa or salon',
} as const;

export const DEFAULT_SEARCH_PROVIDER = 'yelp';
export const SEARCH_PROVIDER_TEXT = {
    yelp: 'Yelp',
    google: 'Google',
};
export const SEARCH_PROVIDERS = {
  YELP: 'yelp',
  GOOGLE: 'google',
};

export const DEFAULT_PRICES = [1000, 2500, 5000, 10000, 25000];//Value is in cents
export const DEFAULT_MIN_PRICE = 10;//Value is in dollars

export const WP_CONTENT_IMAGES_PATH = `${BASE_URL || ''}/wp-content/themes/giftcardmarket/assets/images`;